import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faStar, faTrash, faTimes } from '@fortawesome/free-solid-svg-icons';

const stripHTML = (html) => html?.replace(/<[^>]*>?/gm, '') || '';
const truncate = (text, max) => (text.length > max ? text.slice(0, max) + '...' : text);

const AgencyTable = ({
  agencies,
  showIndex = false,
  onApprove,       
  onDelete,
  onFeature,
  allowFeature = false,
  allowApproveToggle = true,
  startIndex = 0
}) => {
  return (
    <table className="min-w-full bg-gray-100 table-auto text-left my-6 border border-gray-600">
      <thead className="bg-gray-200 text-gray-700 text-lg">
        <tr>
          {showIndex && <th className="border border-gray-600 px-4 py-2 w-1/12">#</th>}
          <th className="border border-gray-600 px-4 py-2 w-1/6">Logo</th>
          <th className="border border-gray-600 px-4 py-2 w-1/6">Name</th>
          <th className="border border-gray-600 px-4 py-2 w-1/6">Services</th>
          <th className="border border-gray-600 px-4 py-2 w-2/6">Description</th>
          <th className="border border-gray-600 px-4 py-2 w-1/6">Actions</th>
        </tr>
      </thead>
      <tbody>
        {agencies.map((agency, index) => (
          <tr key={agency.id} className="border-b border-gray-600 hover:bg-gray-100 transition">
            {showIndex && <td className="py-3 px-4 border border-gray-600 text-center">{startIndex + index + 1}</td>}

            <td className="py-3 px-4 border border-gray-600">
              <img src={agency.logo || '/placeholder.png'} alt={agency.name} className="h-12 object-contain" />
            </td>

            <td
              className="py-3 px-4 border border-gray-600 text-secondary font-semibold cursor-pointer hover:underline"
              onClick={() => window.open(`${process.env.REACT_APP_BASE_URL}/agency/${agency.id}`, '_blank')}
            >
              {agency.name}
            </td>

            <td className="py-3 px-4 border border-gray-600">
              <div className="flex flex-wrap gap-1 overflow-auto max-h-[100px]">
                {agency.services?.map((service, i) => (
                  <span key={i} className="border border-primary text-primary text-xs px-2 py-1 rounded-lg">
                    {service}
                  </span>
                ))}
              </div>
            </td>

            <td className="py-3 px-4 border border-gray-600 text-gray-600">
              {truncate(stripHTML(agency.description || ''), 100)}
            </td>

            <td className="py-3 px-4 border border-gray-600">
              <div className="flex justify-between items-center gap-2">
                {allowApproveToggle && (
                  <button
                    onClick={() => onApprove(agency.id)}
                    className={`p-2 rounded ${agency.isApproved ? 'text-red-600 hover:bg-red-600 hover:text-white' : 'text-green-600 hover:bg-green-600 hover:text-white'}`}
                    title={agency.isApproved ? 'Disapprove Agency' : 'Approve Agency'}
                  >
                    <FontAwesomeIcon icon={agency.isApproved ? faTimes : faCheck} />
                  </button>
                )}

                {allowFeature && onFeature && (
                  <button
                    onClick={() => onFeature(agency.id, agency.isFeaturable)}
                    disabled={!agency.isFeaturable}
                    className={`p-2 rounded ${
                      agency.isFeaturable
                        ? agency.isFeatured
                          ? 'bg-yellow-500 text-white'
                          : 'text-yellow-500'
                        : 'text-gray-400 cursor-not-allowed'
                    }`}
                  >
                    <FontAwesomeIcon icon={faStar} />
                  </button>
                )}

                <button
                  onClick={() => onDelete(agency.id)}
                  className="text-red-500 p-2 rounded hover:bg-red-500 hover:text-white"
                  title="Delete Agency"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AgencyTable;
